import type { ReactElement, ReactNode } from "react";

import { styled } from "simplydo/react/styled";

import { StyledTabPane, tabPaneClassName } from "./Tab.styles";
import type { TabPaneProps } from "./Tab.types";

const TabPaneComponent = (props: TabPaneProps): ReactElement => {
  const { active = true, children, content, className, style, loading } = props;

  const body = content !== undefined ? content : children;

  return (
    <StyledTabPane
      className={tabPaneClassName(className, loading)}
      style={style}
      $active={active}
    >
      {body as ReactNode}
    </StyledTabPane>
  );
};

export const TabPane = styled(TabPaneComponent)``;
